import { flow } from 'lodash';

import { provideAuthenticationServices } from '@/authentication/di';
import { providePermissionServices } from '@/permissions/di';

import { ServiceTokens } from './tokens';
import { baseInjector } from './base-injector';
import type { GetInjectionContext } from './types';

const mainInjector = flow(provideAuthenticationServices, providePermissionServices)(baseInjector);

export type MainInjector = typeof mainInjector;
export type MainInjectionContext = GetInjectionContext<MainInjector>;

export { mainInjector, ServiceTokens };
